
import React, { useEffect, useState } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';

import {useWindowSize} from 'react-use';

import { Breakpoint, useTheme } from '@mui/system';
import { useMediaQuery } from '@mui/material';

import { currentBasicTextFilterPropsAtom, currentFormNameAtom, currentUserSessionAtom, isSaveLoadingAtom } from 'library/store';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';


import { DatePicker } from '@mui/x-date-pickers';
import TextField, { TextFieldProps } from '@mui/material/TextField';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { flexBetween, flexBetweenCenter, flexCenter, justifyCenter, typographyGroupBoxStyling } from 'themes/commonStyles';

import useContractService from 'features/production/services/Contract';

import { BasicTextFilterForm, defaultBasicTextFilterProps } from 'components/ui/BasicTextFilterForm';


// import WidgetSummary from './widgets/WidgetSummary';
// import WidgetBarChart from './widgets/WidgetBarChart';
// import WidgetPieChart from './widgets/WidgetPieChart';
import { Button } from '@mui/material';
import { MdOutlineChangeCircle } from 'react-icons/md';
import { FormDialog } from 'components/ui/FormDialog';
import { IContractMessageDashboardDay, defaultContractMessageDashboardDay } from 'features/production/models/Contract';
import WidgetSummary from 'features/widgets/WidgetSummary';
import WidgetBarChart from 'features/widgets/WidgetBarChart';
import WidgetPieChart from 'features/widgets/WidgetPieChart';


export const ContractMessageDashboardForm = () => {

  const theme = useTheme();

  const { t, i18n } = useTranslation();

  const [currentFormName, setCurrentFormName] = useRecoilState(currentFormNameAtom);
  const [isSaveLoading, setIsSaveLoading] = useRecoilState(isSaveLoadingAtom);

  const {language: lg, applicationSetup } = useRecoilValue(currentUserSessionAtom);
  
  const [currentBasicTextFilterProps, setCurrentBasicTextFilterProps] = useRecoilState(currentBasicTextFilterPropsAtom);

  const {height, width} = useWindowSize();
  const isSm = useMediaQuery( theme.breakpoints.down('sm'));

  const {getContractMessageDayDashboard} = useContractService();
  const [dashboard, setDashboard] = useState<IContractMessageDashboardDay>(defaultContractMessageDashboardDay);

  // const [openSchoolYearFilter, setOpenSchoolYearFilter] = useState(false);
  // const basicFilterSchoolYear = useBasicFilterSchoolYear( 
  //     async (event: React.MouseEvent<unknown>, row: ISchoolYear) => {
  //         const {id, name } = row;

  //         const dash = await getSchoolYearDashboard(id);
  //         setSchoolYearName(name);

  //         setDashboard(dash);
  //         setOpenSchoolYearFilter(false);
  //     }
  // );


  const handleClickSelectSchoolYear = (event: any) => {
    //setOpenSchoolYearFilter(true);
  }


  useEffect( () => {        
    setCurrentFormName(`${t('Dashboard')} - ${t('Message')}`);
    setCurrentBasicTextFilterProps(defaultBasicTextFilterProps);
    setIsSaveLoading(false);
  }, []);    

const [dateFrom, setDateFrom] = React.useState<Date>(new Date());
const [dateTo, setDateTo] = React.useState<Date>(new Date());

  useEffect(() => {
    async function _() {
            
      const dash = await getContractMessageDayDashboard(dateFrom, dateTo);            
      setDashboard(dash);     
    }
    _();
  }, [dateFrom, dateTo]);
  
  return (
    <Box sx={{ mx: 0.1 }}>
      <Grid container rowSpacing={1} columnSpacing={3}>
        <Grid item xs={12}>
          <Stack flexDirection='column'>
            <Box sx={{ ...justifyCenter, mt: 0.25, mb: 0.25 }} >
              <Button>
                <Typography  variant="h6" id="tableTitle" color="primary" noWrap sx={{...typographyGroupBoxStyling}}>
                  {`:::: ${t('The day from')} : `}
                </Typography>                
              </Button>              
              <DatePicker                      //label={t('Appointment date')} 
                //renderInput={(params) => <TextField {...params} sx={{width: isSm?'calc(30% - 8px)':'calc(10% - 8px)'}} />}
                slotProps={{ textField: { sx: {width:isSm?'calc(30% - 8px)':'calc(10% - 8px)'}  }} }
                onChange={(newValue) => setDateFrom(newValue||new Date())}                    
                value={dateFrom}                      
              /> 
              <Button>
                <Typography  variant="h6" id="tableTitle" color="primary" noWrap sx={{...typographyGroupBoxStyling}}>
                  {`:::: ${t('to')} `}
                </Typography>                
              </Button>              
              <DatePicker                      //label={t('Appointment date')} 
              
              slotProps={{ textField: { sx: {width:isSm?'calc(30% - 8px)':'calc(10% - 8px)'}  }} }
                onChange={(newValue) => setDateTo(newValue||new Date())}                    
                value={dateTo}                      
              /> 
            </Box>
            
          </Stack>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <WidgetSummary title={`- ${t('Messages')} `} key={` Messages ${dateFrom} ${dateTo}`} paletteColor={theme.palette['info']} 
                iconName='IoSendSharp' total={dashboard.messageCount}  />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <WidgetSummary title={` - ${t('Non ticketable messages')} `} key={` Validated tickets ${dateFrom} ${dateTo} `} paletteColor={theme.palette['success']} 
                iconName='IoSendOutline' total={dashboard.nonTicketableMessageCount}  />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <WidgetSummary title={` - ${t('Ticketable messages')} `}  key={` Messages ${dateFrom} ${dateTo} `} paletteColor={theme.palette['warning']}  
                iconName='MdCallReceived' total={dashboard.ticketableMessageCount}  />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <WidgetSummary title={`${t('Not ticketable defined messages')} `} key={` Unticketed messages ${dateFrom} ${dateTo} `} paletteColor={theme.palette['success']} 
                iconName='MdContacts' total={dashboard.newMessageCount}  />
        </Grid>
        <Grid item xs={12} md={6} lg={6} key={` - `}>
          <WidgetPieChart title={`${t('Ticketable messages')}`} subheader=''
                // chartData={[
                //   { label: 'America', value: 4344 },
                //   { label: 'Asia', value: 5435 },
                //   { label: 'Europe', value: 1443 },
                //   { label: 'Africa', value: 4443 },
                // ]}
                //chartData={ dashboard.monthMessagesByType.map( x => ({...x, label: _mt.has(x.label)? _mt.get(x.label)??x.label :x.label }) )}
                chartData={ dashboard.messageCountPerTicketable}
                chartColors={[
                  theme.palette.primary.main,
                  theme.palette.info.main,
                  theme.palette.warning.main,
                  theme.palette.error.main,
                ]}/>
        </Grid>
        <Grid item xs={12} md={6} lg={6}>
            <WidgetPieChart title={`${t('Messages ticketable affected to ticket')}`} subheader=''
                // chartData={[
                //   { label: 'America', value: 4344 },
                //   { label: 'Asia', value: 5435 },
                //   { label: 'Europe', value: 1443 },
                //   { label: 'Africa', value: 4443 },
                // ]}
                //chartData={ dashboard.monthMessagesByType.map( x => ({...x, label: _mt.has(x.label)? _mt.get(x.label)??x.label :x.label }) )}
                chartData={ dashboard.messageCountPerTicketAssign}
                chartColors={[
                  theme.palette.primary.main,
                  theme.palette.info.main,
                  theme.palette.warning.main,
                  theme.palette.error.main,
                ]}/>               
        </Grid>
              
      </Grid>
      
    </Box>
  )
}
